module.exports = __webpack_public_path__ + "img/try_3.0a07b8da.png";